import service from '@/utils/server';

const modName='/bd/qrCode/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const qrCodeDetails = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};

export const updateQrCode = data => {
  return service({
    url: modName + 'updateQrCode',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/qc/qrCode/api/index.js